import React from 'react'
import { Link } from 'react-router-dom'
import Translation from '../Translation/cont/Translation'


const ButtonLink = ({pathname, className, spanClassName, transId, text, hideText = true, disabled = false, outOfRouting=false, target="_self"}) => {
    const extraSpanClass = spanClassName ? ' ' + spanClassName : ''
    const spanClass = hideText ? "screen-reader-text" : "text" + extraSpanClass
    const innerSpan = <span className={spanClass}><Translation id={transId}>{text}</Translation></span>

    if(disabled) {
        return <span className={'button ' + className}>{innerSpan}</span>
    } else if(outOfRouting) {
        return <a href={pathname} className={'button ' + className} target={target}>{innerSpan}</a>
    } else {
        return <Link to={{pathname: pathname}} className={'button ' + className}>{innerSpan}</Link>
    }
}

export default ButtonLink